"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcModalBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var helpers_2 = require("../../../common/helpers");
var bc_modal_constants_1 = require("./bc-modal-constants");
var BcModalBehavior = (function (_super) {
    __extends(BcModalBehavior, _super);
    function BcModalBehavior() {
        var _this = _super.call(this) || this;
        _this.validateOverflow = false;
        _this.isMainButtonConfigured = false;
        _this.isSecondaryButtonConfigured = false;
        _this.eventClosedAdded = false;
        _this.eventClosedEsc = true;
        _this.body = document.querySelector('body');
        _this.modalState = bc_modal_constants_1.BcModalConstants.CLOSE_STATE_MODAL;
        _this.mainButtonHandler = function () { };
        _this.secondaryButtonHandler = function () { };
        return _this;
    }
    BcModalBehavior.setUpAll = function () {
        var modalElements = Array.from(document.querySelectorAll("article[class='".concat(bc_modal_constants_1.BcModalConstants.MODAL, "']")));
        var elements = [];
        for (var _i = 0, modalElements_1 = modalElements; _i < modalElements_1.length; _i++) {
            var modal = modalElements_1[_i];
            var bcModalBehavior = new BcModalBehavior();
            bcModalBehavior.setElement(modal);
            bcModalBehavior.setUp();
            elements.push(bcModalBehavior);
        }
        return elements;
    };
    BcModalBehavior.prototype._setUp = function () {
        var _this = this;
        this.getElement();
        this.closeButton = this.mySelf.querySelector("button[class*='".concat(bc_modal_constants_1.BcModalConstants.BC_MODAL_CLOSE, "']"));
        this.configEventListener();
        if (this.closeButton && !this.eventClosedAdded) {
            this.closeButton.removeEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.closeModal(bc_modal_constants_1.BcModalConstants.ID_CLOSE_BUTTON); });
            this.closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () { return _this.closeModal(bc_modal_constants_1.BcModalConstants.ID_CLOSE_BUTTON); });
            this.eventClosedAdded = true;
        }
        this.accessibility();
        this.optionalClose();
        this.closeEventKey();
        if (this.closeButton !== null) {
            this.setEventToCloseBtn();
        }
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CHANGE, function () {
            _this.cleanStyleModal();
            _this.setMaxHeightParragraphModal();
        });
        this.addRezise();
    };
    BcModalBehavior.prototype.createOverlay = function () {
        var status = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.DIV_TAG,
            classList: [bc_modal_constants_1.BcModalConstants.BC_MODAL_OVERLAY],
        });
        document.body.insertBefore(status, null);
    };
    BcModalBehavior.prototype.accessibility = function () {
        var _this = this;
        (0, helpers_2.addFocusable)(this.closeButton, { tabindex: '0' }, { event: function () { return _this.closeModal(bc_modal_constants_1.BcModalConstants.ID_CLOSE_BUTTON); } });
        (0, helpers_2.addFocusable)(this.mainButton, { tabindex: '0' }, { event: function () { return _this.configEventListener(); } });
        (0, helpers_2.addFocusable)(this.secondaryButton, { tabindex: '0' }, { event: function () { return _this.configEventListener(); } });
    };
    BcModalBehavior.prototype.getElement = function () {
        this.mainButton = this.mySelf.querySelector(".".concat(bc_modal_constants_1.BcModalConstants.BC_MODAL_BUTTON_CONTAINER, " .").concat(common_constants_1.BcCommonConstants.BTN_PRIMARY_CLASS));
        this.secondaryButton = this.mySelf.querySelector(".".concat(bc_modal_constants_1.BcModalConstants.BC_MODAL_BUTTON_CONTAINER, " .").concat(common_constants_1.BcCommonConstants.BTN_SECONDARY_CLASS));
        this.isMainButtonConfigured = common_constants_1.BcCommonConstants.FALSE;
        this.isSecondaryButtonConfigured = common_constants_1.BcCommonConstants.FALSE;
        this.modalOverlay = this.mySelf.querySelector("article[class='".concat(bc_modal_constants_1.BcModalConstants.MODAL, "']"));
        this.setWithButtonsEquals(this.mainButton, this.secondaryButton);
    };
    BcModalBehavior.prototype.configEventListener = function () {
        var _this = this;
        if (this.callback) {
            if (this.mainButton) {
                this.mainButton.removeEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.mainButtonHandler);
                this.mainButtonHandler = function () { return _this.callback(bc_modal_constants_1.BcModalConstants.MAIN_TASK); };
                this.mainButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.mainButtonHandler);
            }
            if (this.secondaryButton) {
                this.secondaryButton.removeEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.secondaryButtonHandler);
                this.secondaryButtonHandler = function () { return _this.callback(bc_modal_constants_1.BcModalConstants.SECONDARY_TASK); };
                this.secondaryButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, this.secondaryButtonHandler);
            }
        }
    };
    BcModalBehavior.prototype.optionalClose = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (event.target.classList.contains(bc_modal_constants_1.BcModalConstants.MODAL_ACTIVE) &&
                _this.modalState === 1) {
                _this.closeModal(bc_modal_constants_1.BcModalConstants.ID_CLOSE_OUTSIDE);
            }
        });
    };
    BcModalBehavior.prototype.validateButtonContainerContent = function () {
        var _this = this;
        var modalContent = this.mySelf.getElementsByClassName(bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTENT)[0];
        var modalContainer = this.mySelf.getElementsByClassName(bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTAINER)[0];
        var modalContentButton = this.mySelf.getElementsByClassName(bc_modal_constants_1.BcModalConstants.BC_MODAL_BUTTON_CONTAINER)[0];
        var cordModalButton = modalContentButton.getBoundingClientRect();
        var cordModalContenedor = modalContainer.getBoundingClientRect();
        if (window.innerHeight > bc_modal_constants_1.BcModalConstants.WINDOW_750) {
            if (cordModalContenedor.bottom > cordModalButton.bottom) {
                modalContent.style.height = '';
            }
        }
        if (cordModalContenedor.bottom < cordModalButton.bottom) {
            var cal = modalContainer.clientHeight;
            modalContent.style.height = "".concat(cal * bc_modal_constants_1.BcModalConstants.WINDOW_CAL_3, "px");
        }
        modalContent.style.height = '';
        if (this.validateOverflow) {
            setTimeout(function () {
                _this.validateContent(modalContainer, modalContent);
            });
        }
    };
    BcModalBehavior.prototype.validateContent = function (modalContainer, modalContent) {
        modalContent.style.height = '';
        var diffHeight = modalContent.clientHeight - modalContainer.clientHeight;
        if (this.isSecondaryButtonConfigured) {
            this.validateHeigthModalUpdate(diffHeight, modalContent, modalContainer, bc_modal_constants_1.BcModalConstants.HEIGHT_SIMPLE_BUTTONS);
        }
        else {
            this.validateHeigthModalUpdate(diffHeight, modalContent, modalContainer, bc_modal_constants_1.BcModalConstants.HEIGHT_DOUBLE_BUTTONS);
        }
    };
    BcModalBehavior.prototype.validateHeigthModalUpdate = function (diffHeight, modalContent, modalContainer, heightConstant) {
        if (diffHeight < common_constants_1.COMMON_CONSTANTS_NUMBERS.N0 || modalContent.clientHeight > modalContainer.clientHeight) {
            modalContent.style.height = "".concat(modalContainer.clientHeight - heightConstant, "px");
        }
        else {
            modalContent.style.height = '';
        }
    };
    BcModalBehavior.prototype.addRezise = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_RESIZE, function () {
            _this.cleanStyleModal();
            _this.validateButtonContainerContent();
            _this.setMaxHeightParragraphModal();
        });
    };
    BcModalBehavior.prototype.closeEventKey = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                if (_this.eventClosedEsc) {
                    _this.closeModal(bc_modal_constants_1.BcModalConstants.ID_CLOSE_ESC);
                }
            }
        });
    };
    BcModalBehavior.prototype.setEventCloseEsc = function (value) {
        this.eventClosedEsc = value;
    };
    BcModalBehavior.prototype.openModal = function () {
        this.modalState = bc_modal_constants_1.BcModalConstants.OPEN_STATE_MODAL;
        this.changeState();
        this.createOverlay();
        this.cleanStyleModal();
        this.setMaxHeightParragraphModal();
        this.getElement();
        this.body.style.overflow = 'hidden';
        this.validateButtonContainerContent();
        this.validateinputdate(bc_modal_constants_1.BcModalConstants.BC_MODAL_INPUT_DATE_RANGE);
        var keyValidation = this.mySelf.querySelector(bc_modal_constants_1.BcModalConstants.BC_MODAL_CLASS);
        this.trapFocus(keyValidation);
        this.closeTooltips();
    };
    BcModalBehavior.prototype.trapFocus = function (element) {
        if (!element) {
            return;
        }
        var focusableElements = element.querySelectorAll("".concat(common_constants_1.BcCommonConstants.BUTTON_TAG, ", ").concat(common_constants_1.BcCommonConstants.HREF_TAG, ", ").concat(common_constants_1.BcCommonConstants.INPUT_TAG, ", ").concat(common_constants_1.BcCommonConstants.TEXTAREA_TAG, ", ").concat(common_constants_1.BcCommonConstants.SELECT_TAG, ", ").concat(common_constants_1.BcCommonConstants.SELECT_TAG, ", ").concat(bc_modal_constants_1.BcModalConstants.BC_BUTTON_CLOSED, ", [").concat(common_constants_1.BcCommonConstants.TABINDEX, "]"));
        var enabledFocusableElements = Array.from(focusableElements).filter(function (el) { return !el.disabled; });
        var firstElement = enabledFocusableElements[0];
        var lastElement = enabledFocusableElements[enabledFocusableElements.length - 1];
        setTimeout(function () {
            lastElement.focus();
        }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N200);
        element.addEventListener("".concat(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN), function (event) {
            var isTabPressed = event.key === "".concat(common_constants_1.BcCommonConstants.KEY_TAB) || event.keyCode === common_constants_1.COMMON_CONSTANTS_NUMBERS.N9;
            if (!isTabPressed) {
                return;
            }
            if (event.shiftKey) {
                if (document.activeElement === firstElement) {
                    lastElement.focus();
                    event.preventDefault();
                }
            }
            else {
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                    event.preventDefault();
                }
            }
        });
    };
    BcModalBehavior.prototype.validateinputdate = function (modalInputClass) {
        var dropActivos = Array.from(document.getElementsByClassName(modalInputClass));
        dropActivos.forEach(function (item) {
            var toogle = item.getElementsByClassName(bc_modal_constants_1.BcModalConstants.BC_MODAL_DROPDOWN)[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0];
            var toogleActive = item.getElementsByClassName(bc_modal_constants_1.BcModalConstants.BC_MODAL_DROPDOWN_ACTIVE)[common_constants_1.COMMON_CONSTANTS_NUMBERS.N0];
            if (toogle) {
                toogle.dispatchEvent(new Event(common_constants_1.BcCommonConstants.EVENT_CLICK));
            }
            else if (toogleActive) {
                toogleActive.dispatchEvent(new Event(common_constants_1.BcCommonConstants.EVENT_CLICK));
            }
        });
    };
    BcModalBehavior.prototype.closeModal = function (eventId) {
        if (this.modalState > 0 && this.closeModalCallback) {
            this.closeModalCallback(eventId);
        }
        this.modalState = bc_modal_constants_1.BcModalConstants.CLOSE_STATE_MODAL;
        this.changeState();
        var overlayElement = document.querySelector(".".concat(bc_modal_constants_1.BcModalConstants.BC_MODAL_OVERLAY));
        if (overlayElement) {
            overlayElement.remove();
        }
        this.cleanStylesButton();
        this.body.style.overflow = '';
    };
    BcModalBehavior.prototype.changeState = function () {
        if (this.modalState === bc_modal_constants_1.BcModalConstants.OPEN_STATE_MODAL) {
            this.mySelf.classList.replace(bc_modal_constants_1.BcModalConstants.MODAL, bc_modal_constants_1.BcModalConstants.MODAL_ACTIVE);
        }
        else if (this.modalState === bc_modal_constants_1.BcModalConstants.CLOSE_STATE_MODAL) {
            this.mySelf.classList.replace(bc_modal_constants_1.BcModalConstants.MODAL_ACTIVE, bc_modal_constants_1.BcModalConstants.MODAL);
        }
    };
    BcModalBehavior.prototype.setEventToCloseBtn = function () {
        var _this = this;
        this.closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.closeModal(bc_modal_constants_1.BcModalConstants.ID_CLOSE_BUTTON);
        });
    };
    BcModalBehavior.prototype.setWithButtonsEquals = function (mainButton, secondaryButton) {
        if (!this.mainButton || !this.secondaryButton) {
            return;
        }
        var mainButtonWith = 0;
        var mainButtonHeight = 0;
        var secondaryButtonWith = 0;
        var secondaryButtonHeight = 0;
        mainButtonWith = mainButton.offsetWidth;
        mainButtonHeight = mainButton.offsetHeight;
        secondaryButtonWith = secondaryButton.offsetWidth;
        secondaryButtonHeight = secondaryButton.offsetHeight;
        var maxWith = Math.max(mainButtonWith, secondaryButtonWith);
        var maxHeight = Math.max(mainButtonHeight, secondaryButtonHeight);
        if (maxWith > mainButtonWith || maxWith > secondaryButtonWith) {
            this.mainButton['style'].width = maxWith + 'px';
            this.secondaryButton['style'].width = maxWith + 'px';
        }
        if (maxHeight > mainButtonHeight || maxHeight > secondaryButtonHeight) {
            this.mainButton['style'].height = maxHeight + 'px';
            this.secondaryButton['style'].height = maxHeight + 'px';
        }
    };
    BcModalBehavior.prototype.cleanStylesButton = function () {
        if (this.mainButton) {
            this.mainButton.style.cssText = '';
        }
        if (this.secondaryButton) {
            this.secondaryButton.style.cssText = '';
        }
    };
    BcModalBehavior.prototype.getMaxHeightModal = function (maxHeightPercentage) {
        return Math.trunc(window.innerHeight * (maxHeightPercentage / bc_modal_constants_1.BcModalConstants.ONE_HUNDRED_PERCENT));
    };
    BcModalBehavior.prototype.getPaddingYHtmlElement = function (htmlElement) {
        var elementStyle = getComputedStyle(htmlElement);
        return parseInt(elementStyle.paddingTop) + parseInt(elementStyle.paddingBottom);
    };
    BcModalBehavior.prototype.getElementsSectionList = function () {
        return Array.from(this.mySelf.querySelectorAll(".".concat(bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTAINER, " section")));
    };
    BcModalBehavior.prototype.getTotalHeightSections = function (listSectionsModal) {
        return listSectionsModal.reduce(function (prev, current) {
            if (current.className !== bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTENT) {
                return prev + (current.offsetHeight + parseInt(current.style.marginTop ? current.style.marginTop : '0') + parseInt(current.style.marginBottom ? current.style.marginBottom : '0'));
            }
            return prev;
        }, 0);
    };
    BcModalBehavior.prototype.getSectionHmtlByClassName = function (listSectionsModal, classname) {
        return listSectionsModal.find(function (section) { return section.classList.contains(classname); });
    };
    BcModalBehavior.prototype.getMarginYHtmlElement = function (sectionParagraphModal) {
        var elementStyle = getComputedStyle(sectionParagraphModal);
        return parseInt(elementStyle.marginTop) + parseInt(elementStyle.marginBottom);
    };
    BcModalBehavior.prototype.cleanStyleModal = function () {
        var listSectionsModal = this.getElementsSectionList();
        var sectionParagraphModal = this.getSectionHmtlByClassName(listSectionsModal, bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTENT);
        sectionParagraphModal.style.removeProperty(bc_modal_constants_1.BcModalConstants.MAX_HEIGHT_ATTRIBUTE);
    };
    BcModalBehavior.prototype.setMaxHeightParragraphModal = function () {
        var containerModal = this.mySelf.querySelector(".".concat(bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTAINER));
        if (!(containerModal instanceof HTMLElement)) {
            return;
        }
        var maxHeightModal = this.getMaxHeightModal(bc_modal_constants_1.BcModalConstants.MODAL_MAX_HEIGHT_PERCENTAGE);
        if (containerModal.clientHeight < maxHeightModal) {
            return;
        }
        var paddingYcontainerModal = this.getPaddingYHtmlElement(containerModal);
        var heightContainerModal = containerModal.clientHeight - paddingYcontainerModal;
        var listSectionsModal = this.getElementsSectionList();
        var totalHeigthSections = this.getTotalHeightSections(listSectionsModal);
        var sectionParagraphModal = this.getSectionHmtlByClassName(listSectionsModal, bc_modal_constants_1.BcModalConstants.BC_MODAL_CONTENT);
        var marginYsectionParagraphModal = this.getMarginYHtmlElement(sectionParagraphModal);
        var maxHeightParragraph = heightContainerModal - (totalHeigthSections + marginYsectionParagraphModal);
        sectionParagraphModal.style.maxHeight = "".concat(maxHeightParragraph, "px");
    };
    BcModalBehavior.prototype.closeTooltips = function () {
        if (window.innerWidth < bc_modal_constants_1.BcModalConstants.BC_MODAL_N991) {
            var tooltipElements = Array.from(document.querySelectorAll(".".concat(bc_modal_constants_1.BcModalConstants.BC_TOOLTIP_CONTAINER_SELECTOR)));
            tooltipElements.forEach(function (tooltipElement) {
                var tooltip = tooltipElement;
                tooltip.style.animation = bc_modal_constants_1.BcModalConstants.BC_TOOLTIP_CLOSE_ANIMATION;
            });
        }
    };
    return BcModalBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcModalBehavior = BcModalBehavior;
